import EmailPreferences from './email-preferences'

export default EmailPreferences
